//global adsbygoogle
(function() {
    'use strict';
    angular
        .module('emarket.commons')
        .directive('emBanner', ['$log', '$window', '$templateCache', '$compile', '$timeout', function($log, $window, $templateCache, $compile, $timeout) {
            var images = [ '../assets/banner-300x250.jpg', '../assets/banner-300x250-2.gif' ];
            var clientId = 'ca-pub-6593085274242640';
            return {
                scope: {
                    size: '@',
                    slot: '=',
                    image: '='
                },
                controller: [
                    '$scope',
                    '$state',
                    '$rootScope',
                    '$mdMedia',
                    function($scope, $state, $rootScope, $mdMedia) {
                        $scope.img = images[Math.round(Math.random() * 1)];
                        var mobileSizes = [ '320x50', '320x100' ];
                        var hideBanner = function() {
                            if ($state.current.data && $state.current.data.hideBanner === $scope.size) {
                                $scope.hide = true;
                            } else {
                                $scope.hide = false;
                            }
                            if (!$mdMedia('gt-sm') && mobileSizes.indexOf($scope.size) === -1) {
                                $scope.hide = true;
                            }
                            if ($mdMedia('gt-sm') && mobileSizes.indexOf($scope.size) !== -1) {
                                $scope.hide = true;
                            }
                        };
                        hideBanner();
                        var ev = $rootScope.$on('$stateChangeSuccess', function() {
                            hideBanner();
                        });
                        var sizes = $scope.size.split('x');

                        $scope.styles = {
                            width: sizes[0] + 'px',
                            height: sizes[1] + 'px'
                        };
                        $scope.$on('$destroy', function() {
                            ev();
                        });
                    }
                ],
                link: function(scope, element) {
                    var sizes = scope.size.split('x');
                    var adsbygoogle = $window.adsbygoogle || [];
                    scope.clientId = clientId;
                    element.css({
                        width: sizes[0] + 'px',
                        height: sizes[1] + 'px'
                    });
                    var template;
                    var compileTemplate;
                    if (scope.slot && scope.size) {
                        template = $templateCache.get('directives/banner/ins.tpl.html');
                        compileTemplate = $compile(template)(scope);
                        $(compileTemplate).css({
                            width: sizes[0] + 'px',
                            height: sizes[1] + 'px'
                        });
                    }
                    if (scope.image) {
                        template = $templateCache.get('directives/banner/image.tpl.html');
                        compileTemplate = $compile(template)(scope);
                    }
                    element.find('.em-banner').append(compileTemplate);

                    if (scope.slot) {
                        $timeout(function() {
                            adsbygoogle.push({});
                        }, 100);
                    }
                    scope.$watch(function() {
                        return scope.hide;
                    },
                    function() {
                        if (scope.hide) {
                            element.css('display', 'none');
                        } else {
                            element.css('display', 'block');
                        }
                    });
                    // var banner = 'directives/banner/banner-' + scope.size + '.tpl.html';
                    // var template = $templateCache.get(banner);
                    // var compiledTemplate = $compile(template)(scope);
                    // element.append(compiledTemplate);
                },

                // templateUrl: function(elem, attrs) {
                //     // console.log('directives/banner/banner-' + attrs.size);
                //     return 'directives/banner/banner-' + attrs.size + '.tpl.html';
                //     // return 'directives/banner/banner-generic.tpl.html';
                // }
                templateUrl: 'directives/banner/banner-generic.tpl.html'
            };
        }]);
}());
